var map = {
	"./css/index.css": "a2f0",
	"./data/site-data": "9ce2",
	"./data/site-data.json": "9ce2",
	"./images/SkillsTown-Logo.png": "c569",
	"./images/bg1.jpg": "9970",
	"./images/bg2.jpg": "101e",
	"./images/bg3.jpg": "6674",
	"./images/deafinition-bg.jpg": "1b00",
	"./images/deafinition_logo_pic.png": "857d",
	"./images/deafinition_text_logo.png": "0103",
	"./images/edeaf-journey.jpg": "3d07",
	"./images/home_hero.jpg": "32d8",
	"./images/logo_large.png": "7491",
	"./images/logo_small.png": "7a5d",
	"./images/mockup-academy-SA.jpg": "36cf",
	"./images/nazereen.jpg": "1ffb",
	"./images/partnered-solutions.png": "1793",
	"./images/values-wheel.png": "2ccf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";